import axios from 'axios';
import Vue from 'vue';

const actions = {
    getNotifications: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/notifications?shown=false', {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
            ).then(res => {
                return res
            }).catch((err) => {
                return err
        });
    },
    getNotificationHistory: (context, payload) => {
        const { ApiClient, cursor } = payload;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/notifications/history', {
            params: { firebaseIdToken: ApiClient.token, cursor }
        }).catch((err) => err);
    },
    markAllAsViewed: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        
        return axios.post(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/notifications/viewed', {
                firebaseIdToken: ApiClient.token,
                departments: departments,
            }
        ).then(res => {
            return res
        }).catch((err) => {
            return err
        });
    },
    markAsViewed: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const notificationId = payload.notificationId;
       
        return axios.post(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/notification/' + notificationId + '/viewed', {},
            {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
        ).then(res => {
            return res
        }).catch((err) => {
            return err
        });
    },
    getAllReminders: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
       
        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/reminders', {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
        ).then(res => {
            return res
        }).catch((err) => {
            return err
        });
    },
    createReminder: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        
        const body = {
            message: payload.message,
            day: payload.day,
            subject: payload.subject,
            time: payload.time,
            type: payload.type,
            recipients: payload.userIds,
            allowAnswer: payload.allowAnswer !== undefined ? payload.allowAnswer : true
        };

        return axios.post(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/reminder', 
            body,
            {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
        ).then(res => {
            return res
        }).catch((err) => {
            return err
        });
    },
    setActiveOnReminder: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const reminderId = payload.reminderId;
        const active = payload.active;

        return axios.patch(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/reminder/' + reminderId, 
            {
                active
            },
            {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
        ).then(res => {
            return res
        }).catch((err) => {
            return err
        });
    },
    patchReminder: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const reminder = payload.reminder;

        return axios.patch(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/reminder/' + reminder.id, 
            {
                message: reminder.message,
                subject: reminder.subject,
                day: reminder.day,
                time: moment().set({h: reminder.time.split(':')[0], m: reminder.time.split(':')[1]}).utc().format('H:mm'),
                recipients: reminder.recipients,
                type: reminder.type
            },
            {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
        ).then(res => {
            return res
        }).catch((err) => {
            return err
        });
    }, 
    removeReminder: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const reminderId = payload.reminderId;

        return axios.delete(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/reminder/' + reminderId, 
            {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
        ).then(res => {
            return res
        }).catch((err) => {
            return err
        });
    },
}

export default actions
